/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DailyTransactionLogModel } from '../model/dailyTransactionLogModel';
import { MonthlyTransactionLogModel } from '../model/monthlyTransactionLogModel';
import { TransactionLogModelDto } from '../model/transactionLogModelDto';
import { WeeklyTransactionLogModel } from '../model/weeklyTransactionLogModel';
import { YearlyTransactionLogModel } from '../model/yearlyTransactionLogModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TransactionLogService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param serviceProviderId 
     * @param serviceCode 
     * @param msisdn 
     * @param partnerName 
     * @param serviceType 
     * @param dateStart 
     * @param dateEnd 
     * @param direction 
     * @param status 
     * @param keyword 
     * @param route 
     * @param operatorName 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetAllTransactionLog(serviceProviderId?: string, serviceCode?: string, msisdn?: string, partnerName?: string, serviceType?: string, dateStart?: Date, dateEnd?: Date, direction?: string, status?: number, keyword?: string, route?: string, operatorName?: string, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<TransactionLogModelDto>;
    public transactionLogGetAllTransactionLog(serviceProviderId?: string, serviceCode?: string, msisdn?: string, partnerName?: string, serviceType?: string, dateStart?: Date, dateEnd?: Date, direction?: string, status?: number, keyword?: string, route?: string, operatorName?: string, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionLogModelDto>>;
    public transactionLogGetAllTransactionLog(serviceProviderId?: string, serviceCode?: string, msisdn?: string, partnerName?: string, serviceType?: string, dateStart?: Date, dateEnd?: Date, direction?: string, status?: number, keyword?: string, route?: string, operatorName?: string, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionLogModelDto>>;
    public transactionLogGetAllTransactionLog(serviceProviderId?: string, serviceCode?: string, msisdn?: string, partnerName?: string, serviceType?: string, dateStart?: Date, dateEnd?: Date, direction?: string, status?: number, keyword?: string, route?: string, operatorName?: string, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (serviceCode !== undefined && serviceCode !== null) {
            queryParameters = queryParameters.set('serviceCode', <any>serviceCode);
        }
        if (msisdn !== undefined && msisdn !== null) {
            queryParameters = queryParameters.set('msisdn', <any>msisdn);
        }
        if (partnerName !== undefined && partnerName !== null) {
            queryParameters = queryParameters.set('partnerName', <any>partnerName);
        }
        if (serviceType !== undefined && serviceType !== null) {
            queryParameters = queryParameters.set('serviceType', <any>serviceType);
        }
        if (dateStart !== undefined && dateStart !== null) {
            queryParameters = queryParameters.set('dateStart', <any>dateStart.toISOString());
        }
        if (dateEnd !== undefined && dateEnd !== null) {
            queryParameters = queryParameters.set('dateEnd', <any>dateEnd.toISOString());
        }
        if (direction !== undefined && direction !== null) {
            queryParameters = queryParameters.set('direction', <any>direction);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }
        if (route !== undefined && route !== null) {
            queryParameters = queryParameters.set('route', <any>route);
        }
        if (operatorName !== undefined && operatorName !== null) {
            queryParameters = queryParameters.set('operatorName', <any>operatorName);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TransactionLogModelDto>(`${this.basePath}/api/TransactionLog/GetAllTransactionLog`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param spId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetDailyTransactionlogs(spId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DailyTransactionLogModel>>;
    public transactionLogGetDailyTransactionlogs(spId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DailyTransactionLogModel>>>;
    public transactionLogGetDailyTransactionlogs(spId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DailyTransactionLogModel>>>;
    public transactionLogGetDailyTransactionlogs(spId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (spId !== undefined && spId !== null) {
            queryParameters = queryParameters.set('spId', <any>spId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<DailyTransactionLogModel>>(`${this.basePath}/api/TransactionLog/GetDailyTransactionlogs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param spId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetMonthlyTransactionlogs(spId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MonthlyTransactionLogModel>>;
    public transactionLogGetMonthlyTransactionlogs(spId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MonthlyTransactionLogModel>>>;
    public transactionLogGetMonthlyTransactionlogs(spId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MonthlyTransactionLogModel>>>;
    public transactionLogGetMonthlyTransactionlogs(spId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (spId !== undefined && spId !== null) {
            queryParameters = queryParameters.set('spId', <any>spId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<MonthlyTransactionLogModel>>(`${this.basePath}/api/TransactionLog/GetMonthlyTransactionlogs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param spId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetWeeklyTransactionlogs(spId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<WeeklyTransactionLogModel>>;
    public transactionLogGetWeeklyTransactionlogs(spId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<WeeklyTransactionLogModel>>>;
    public transactionLogGetWeeklyTransactionlogs(spId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<WeeklyTransactionLogModel>>>;
    public transactionLogGetWeeklyTransactionlogs(spId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (spId !== undefined && spId !== null) {
            queryParameters = queryParameters.set('spId', <any>spId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<WeeklyTransactionLogModel>>(`${this.basePath}/api/TransactionLog/GetWeeklyTransactionlogs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param spId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetYearlyTransactionlogs(spId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<YearlyTransactionLogModel>>;
    public transactionLogGetYearlyTransactionlogs(spId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<YearlyTransactionLogModel>>>;
    public transactionLogGetYearlyTransactionlogs(spId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<YearlyTransactionLogModel>>>;
    public transactionLogGetYearlyTransactionlogs(spId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (spId !== undefined && spId !== null) {
            queryParameters = queryParameters.set('spId', <any>spId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<YearlyTransactionLogModel>>(`${this.basePath}/api/TransactionLog/GetYearlyTransactionlogs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
